import { createContext, useContext } from 'react';
import type { LayoutSection, LayoutSpec } from '../../types/LayoutConfig';

export interface SpaceConfigContextProps {
  /** `group` is persisted on the space’s `LayoutSpec`. */
  updateSpace: (id: string, config: Partial<LayoutSpec>) => void;
  removeSpace: (id: string) => void;
  spaces: Record<LayoutSection, LayoutSpec[]>;
  setSpaces: (section: LayoutSection, spaces: LayoutSpec[]) => void;
}

/**
 * Provide method for updating AppConfig related to Spaces
 */
export const SpaceConfigContext = createContext<SpaceConfigContextProps>({
  updateSpace: () => {},
  removeSpace: () => {},
  spaces: { trading: [], monitoring: [] },
  setSpaces: () => {},
});
SpaceConfigContext.displayName = 'SpaceConfigContext';

export const useSpacesConfig = (): SpaceConfigContextProps => {
  const { updateSpace, removeSpace, spaces, setSpaces } = useContext(SpaceConfigContext);

  return { updateSpace, removeSpace, spaces, setSpaces };
};
